// extracted by mini-css-extract-plugin
module.exports = {"share_compoment":"Share_share_compoment__TvMT4","refer_modal":"Share_refer_modal__uE8R8","no_active_modal":"Share_no_active_modal__UV0a1"};